<template>
  <div id="app">
    <ImageBanner />
    <b-container>
      <b-row>
        <b-col></b-col>
        <b-col cols="8">
          <b-link class="main-link" href="/foundation">Foundation of All Good Qualities</b-link>
          <b-link class="main-link" href="/dictionary">Tibetan English Dictionary</b-link>
          <b-link class="main-link" href="/gakha">Tibetan Consonants</b-link>
          <b-link class="main-link" href="/gakha/study.html">Tibetan Consonants Flash-card style game</b-link>
          <b-link class="main-link" href="/verses">Yang-jen-ga-way-lo-dro's Grammar Verse</b-link>
          <b-link class="main-link" href="/wheelofsuffering">Debate App (work in progress)</b-link>
        </b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="info-text">Welcome to my ever-growing collection of Tibetan Buddhist resources. If you've somehow managed to get here from
            the wild internet without context, these links are related to my studies at <a href="http://maitripa.org">Matiripa College</a>, in Portland, Oregon.</div>
          <div class="email-container">
            <EmailQuestion email="a.hughes@maitripa.org"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

  import EmailQuestion from './components/EmailQuestion'
  import ImageBanner from './components/ImageBanner'

  export default {
    name: 'home',
    components: {
      EmailQuestion,
      ImageBanner
    },
  }
</script>

<style>

  .email-container {
    margin-top: 20px;
    margin-bottom: 50px;
  }

</style>
